export default __webpack_public_path__ + "static/media/QA.35b1daba.svg";